export default "__VITE_ASSET__CMjSeniv__"